import { CustomerBillingCustomerModel } from './customer-billing-customer.model';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { CurrencyTypes } from '../customer-billing-price/currency-type';
import { ObjectTypes } from '@fi-shared/types/object-type';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { fiPaymentMethodTypeName } from '../payment-method-type';
import { OtherInvoicesListItemComponent } from './other-invoices-list-item/other-invoices-list-item.component';
import { MonthlyInvoicesListItemComponent } from './monthly-invoices-list-item/monthly-invoices-list-item.component';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { createMap } from '@fi-shared/utils/create-map';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class CustomerBillingCustomerListData extends ListData<CustomerBillingCustomerModel> {
    private CurrencyTypesMap = createMap(CurrencyTypes, 'Id');
    constructor(injector: Injector) {
        super(injector);

        this.ShowDelete = false;

        this.ObjectType = ObjectTypes.CustomerBillingCustomer;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.customer'),
                'CustomerName',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: FiStateNames.CustomerBilling.Customers.View,
                    SrefParams: (data) => ({ Id: data.CustomerId }),
                }),
            ),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.payment_method'),
            'PaymentMethodType',
            '',
            true,
            (data, property) => {
                return fiPaymentMethodTypeName(data[property], this.appTextService);
            },
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('customer_billing.monthly_invoices'),
                'CurrentMonthlyInvoice',
                new ItemsListHeaderProperties('', false, MonthlyInvoicesListItemComponent),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('customer_billing.other_invoices'),
                'OtherInvoices',
                new ItemsListHeaderProperties('', false, OtherInvoicesListItemComponent),
            ),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('customer_billing.shut_off_date'),
            'ShutOffDate',
            '',
            true,
            (data, property) => {
                return injector.get(FiFormatDateService).formatDate(data[property], 'date');
            },
        );

        this.addSpanPlainHeader(
            this.appTextService.get('common.discount') + ' %',
            'DiscountGlobal',
            '',
            true,
            this.formatPercents,
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.extra_discount') + ' %',
            'ExtraDiscount',
            '',
            true,
            this.formatPercents,
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.currency'),
            'Currency',
            '',
            false,
            (data, property) => {
                if (
                    data.hasOwnProperty('InvoiceInfo') &&
                    this.CurrencyTypesMap.hasOwnProperty(data.InvoiceInfo[property])
                )
                    return this.appTextService.get(this.CurrencyTypesMap[data.InvoiceInfo[property]].TextId);
                return '-';
            },
        );

        this.getRowClass = (data: CustomerBillingCustomerModel) => {
            if (data.ShutOffDate) return data.ShutOffDate <= new Date() ? 'list-row-red' : 'list-row-blue';
        };
    }

    private formatPercents(data, property) {
        return data[property] > 0 ? data[property] + '%' : '-';
    }
}
